package nl.astraeus.wiki.view

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.html.div
import nl.astraeus.css.properties.Color
import nl.astraeus.css.properties.Display
import nl.astraeus.css.properties.JustifyContent
import nl.astraeus.css.properties.Position
import nl.astraeus.css.properties.prc
import nl.astraeus.css.properties.px
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.komp.Komponent
import nl.astraeus.komp.currentElement
import nl.astraeus.wiki.css.Css
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssId
import nl.astraeus.wiki.css.CssName

class LoadingSplash : Komponent() {

  fun done() {
    this.element?.remove()
  }

  override fun HtmlBuilder.render() {
    div(LoadingCss.name) {
      val element = currentElement()
      window.setTimeout({
        element.classList.add(ShowLoadingCss.name)
      })
    }
  }

  companion object ModalCssObj : CssId("loading") {
    object LoadingCss : CssName
    object ShowLoadingCss : CssName

    init {
      defineCss {
        select(LoadingCss.cls()) {
          display(Display.flex)
          justifyContent(JustifyContent.center)
          transition("background-color 0.25s 0.25s ease-in-out")

          position(Position.fixed)
          zIndex(200)
          left(0.px)
          top(0.px)
          width(100.prc)
          height(100.prc)

          backgroundColor(Color.Companion.transparent)
        }
        select(ShowLoadingCss.cls()) {
          backgroundColor(Css.currentStyle.mainBackgroundColor.changeAlpha(0.5))
        }
      }
    }

    fun load(): LoadingSplash {
      val result = LoadingSplash()
      create(document.body!!, result)
      return result
    }
  }
}
